import { render, staticRenderFns } from "./EventDetailLink.vue?vue&type=template&id=e86d66ce&scoped=true"
import script from "./EventDetailLink.vue?vue&type=script&lang=js"
export * from "./EventDetailLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e86d66ce",
  null
  
)

export default component.exports